import { QueryKeys } from '../../../enums/queryKeys'
import { QueryProps } from '../types/queryProps'

export const getAttachmentsQueryKey = (queryProps: QueryProps): [QueryKeys, QueryProps] => [
  QueryKeys.AttachmentsList,
  queryProps,
]
